import { render } from "./App.vue?vue&type=template&id=c40c8cc0"
const script = {}

import "./App.vue?vue&type=style&index=0&id=c40c8cc0&lang=scss"

import exportComponent from "/github/workspace/merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__